export default {
  tab: {
    order: 'Order',
    portfolio: 'Portfolio',
    assets: 'Assets',
  },

  tradingType: {
    BUY: 'Buy',
    SELL: 'Sell',
  },
  order: {
    Search: 'Ticker',
    UserGuide: 'User Guide',
    ChangeAccount: 'Change Account',
    Logout: 'Logout',
  },
  asserts: {
    MessageFiintrade: 'Fiintrade do not manage your asset information',
    PleaseLogin: 'Please login',
    MessagetoGetMoreInformation: 'to get more information',
  },
};
